import { DictionaryLanguage, RolesValues } from '@constants';
import { createAction } from '@reduxjs/toolkit';

import { FullEmployeeRequest } from '../employees';
import { AdministrationState, ShortEmployeeItem } from './administration.types';

export const resetEmployeesAdministrationsStateAction = createAction(
  'administration/resetEmployeesAdministrationsState',
);

export const selectDomainTypeAction = createAction<string>('administration/selectDomainType');
export const selectDictionaryCandidateSourceAction = createAction<string>(
  'administration/selectDictionaryCandidateSource',
);
export const setDictionarySearchValueAction = createAction<string>('administration/setDictionarySearchValue');

export const setDictionarySortParamsAction = createAction<{ sortLanguage: DictionaryLanguage; sortDirection: string }>(
  'administration/setDictionarySortParams',
);

export const setDictionaryPagableAction = createAction<AdministrationState['dictionaries']['pagable']>(
  'administration/setDictionaryPagable',
);

export const setPagableAction = createAction<AdministrationState['employees']['pagable']>('administration/setPagable');
export const updateUserSelectedAuthDataPermissionsAction = createAction<{
  id: number;
  selectedIds: string[];
  entity: keyof Pick<
    ShortEmployeeItem['authData'],
    'permittedProfessions' | 'permittedVacancies' | 'permittedVacancyRequestIds'
  >;
}>('administration/updateUserSelectedAuthDataPermissions');

export const selectAllUserAuthDataPermissionsAction = createAction<{
  id: number;
  entity: keyof Pick<
    ShortEmployeeItem['authData'],
    'permittedProfessions' | 'permittedVacancies' | 'permittedVacancyRequestIds'
  >;
}>('administration/selectAllUserAuthDataPermissions');

export const unSelectAllUserAuthDataPermissionsAction = createAction<{
  id: number;
  entity: keyof Pick<
    ShortEmployeeItem['authData'],
    'permittedProfessions' | 'permittedVacancies' | 'permittedVacancyRequestIds'
  >;
}>('administration/unSelectAllUserAuthDataPermissions');

export const resetEmployeeFromHrmByEmailAction = createAction('administration/resetEmployeeFromHrmByEmail');

export const setNewEmployeeRoleFromHrmAction = createAction<RolesValues>('administration/setNewEmployeeRoleFromHrm');

export const updateExistingUserRoleAction = createAction<{ id: number; newRole: RolesValues }>(
  'administration/updateExistingUserRole',
);

export const clearCurrentStatusAction = createAction('administration/clearCurrentStatus');
export const clearReferralStateAction = createAction('administration/clearReferralState');
export const clearUnitsStateAction = createAction('administration/clearUnitsState');
export const clearSourcingStateAction = createAction('administration/clearSourcingState');

export const setEmployeeFromHrmToStoreAction = createAction<FullEmployeeRequest>(
  'administration/setEmployeeFromHrmToStore',
);
